import Raven from 'raven-js';
const BOT_USER_AGENT_REGEX = /bot|crawler|spider|googlebot|bingbot|yandex|baidu|slurp|duckduck|facebookexternalhit|linkedinbot|twitterbot|applebot|semrush|ahref|mj12bot|dotbot|petalbot|bytespider|naverbot|yeti|lightpanda|headless|phantomjs|puppeteer|playwright/i;

// laboratory-lib's superstore rejects with this message when IndexedDB is absent
// (headless crawlers). No user impact — matched by message since UA is often
// absent in client-side Raven.
const INDEXEDDB_UNSUPPORTED_MESSAGE = 'IndexedDB is not supported in this environment.';
function isBotUserAgent(data) {
  var _data$request;
  const userAgent = (data === null || data === void 0 || (_data$request = data.request) === null || _data$request === void 0 || (_data$request = _data$request.headers) === null || _data$request === void 0 ? void 0 : _data$request['User-Agent']) || '';
  return BOT_USER_AGENT_REGEX.test(userAgent);
}
function isIndexedDBUnsupported(data) {
  var _data$exception;
  const errorMessage = (data === null || data === void 0 || (_data$exception = data.exception) === null || _data$exception === void 0 || (_data$exception = _data$exception.values) === null || _data$exception === void 0 || (_data$exception = _data$exception[0]) === null || _data$exception === void 0 ? void 0 : _data$exception.value) || '';
  return errorMessage.includes(INDEXEDDB_UNSUPPORTED_MESSAGE);
}

// Lightpanda hits hub-user-info with a 407, rejecting the login-button Promise
// with undefined — noise from hub_generated/template_assets, outside our bundle.
function isCmsTemplateAssetError(data) {
  var _data$exception2, _exception$stacktrace;
  const exception = data === null || data === void 0 || (_data$exception2 = data.exception) === null || _data$exception2 === void 0 || (_data$exception2 = _data$exception2.values) === null || _data$exception2 === void 0 ? void 0 : _data$exception2[0];
  if (!exception) return false;
  const frames = ((_exception$stacktrace = exception.stacktrace) === null || _exception$stacktrace === void 0 ? void 0 : _exception$stacktrace.frames) || [];
  const namedFrames = frames.filter(f => f.filename && f.filename !== '<anonymous>');
  if (namedFrames.length === 0) return false;
  return namedFrames.every(f => {
    var _f$filename;
    return (_f$filename = f.filename) === null || _f$filename === void 0 ? void 0 : _f$filename.includes('/hub_generated/template_assets/');
  });
}

// Chrome 147 (auto-update rollout 2026-04-27) triggers SyntaxError "Invalid or
// unexpected token" at <anonymous>:1:82934 in a third-party inline script
// injected by js.hs-scripts.com/53.js (HubSpot chat/tracking embed). The error
// originates outside our bundle — the <anonymous> filename and HTMLDocument._
// caller confirm it's dynamically injected code. We scope the filter to
// SyntaxErrors from anonymous scripts so legitimate SyntaxErrors from our own
// bundles still surface.
function isThirdPartyInlineSyntaxError(data) {
  var _data$exception3, _exception$value, _exception$stacktrace2;
  const exception = data === null || data === void 0 || (_data$exception3 = data.exception) === null || _data$exception3 === void 0 || (_data$exception3 = _data$exception3.values) === null || _data$exception3 === void 0 ? void 0 : _data$exception3[0];
  if (!exception) return false;
  if (exception.type !== 'SyntaxError') return false;
  if (!((_exception$value = exception.value) !== null && _exception$value !== void 0 && _exception$value.includes('Invalid or unexpected token'))) return false;
  const frames = ((_exception$stacktrace2 = exception.stacktrace) === null || _exception$stacktrace2 === void 0 ? void 0 : _exception$stacktrace2.frames) || [];
  if (frames.length === 0) return true;
  return frames.every(f => !f.filename || f.filename === '<anonymous>');
}
function isNetworkDropError(data) {
  var _data$exception4, _data$breadcrumbs;
  const errorMessage = (data === null || data === void 0 || (_data$exception4 = data.exception) === null || _data$exception4 === void 0 || (_data$exception4 = _data$exception4.values) === null || _data$exception4 === void 0 || (_data$exception4 = _data$exception4[0]) === null || _data$exception4 === void 0 ? void 0 : _data$exception4.value) || '';
  const isChirpOrFetchError = errorMessage.includes('CHIRP RPC failed') || errorMessage.includes('Network request failed') || errorMessage.includes('Failed to fetch') || errorMessage.includes('HTTP RPC failed');
  if (!isChirpOrFetchError) return false;
  const breadcrumbs = (data === null || data === void 0 || (_data$breadcrumbs = data.breadcrumbs) === null || _data$breadcrumbs === void 0 ? void 0 : _data$breadcrumbs.values) || [];
  return breadcrumbs.some(crumb => {
    var _crumb$data, _crumb$data2, _crumb$data3;
    return (crumb.category === 'xhr' || crumb.category === 'fetch') && (((_crumb$data = crumb.data) === null || _crumb$data === void 0 ? void 0 : _crumb$data.status_code) === 0 || ((_crumb$data2 = crumb.data) === null || _crumb$data2 === void 0 ? void 0 : _crumb$data2.status_code) === '0' || ((_crumb$data3 = crumb.data) === null || _crumb$data3 === void 0 ? void 0 : _crumb$data3.status_code) === null);
  });
}
const FILTER_RULES = [isBotUserAgent, isIndexedDBUnsupported, isCmsTemplateAssetError, isThirdPartyInlineSyntaxError, isNetworkDropError];

/* Returns `false` to drop bot/crawler noise before it reaches error reporting. */
export function shouldSendToRaven(data) {
  return !FILTER_RULES.some(rule => rule(data));
}
export function setupRavenFilters() {
  Raven.setShouldSendCallback(shouldSendToRaven);
}